import { Hourglass } from "lucide-react";
import Layout from "@/components/Layout";

export default function ComingSoon({ title, description }) {
  return (
    <Layout>
      <div className="max-w-2xl mx-auto mt-10 animate-fade-in-up" data-testid="coming-soon">
        <div className="bg-card rounded-2xl border border-slate-100 shadow-card p-10 text-center">
          <div className="w-12 h-12 rounded-xl bg-indigo-50 flex items-center justify-center mx-auto mb-5">
            <Hourglass className="w-6 h-6 text-indigo-600" strokeWidth={1.5} />
          </div>
          <h1 className="font-heading text-2xl font-medium text-slate-900 mb-2">{title}</h1>
          <p className="text-sm text-slate-500 leading-relaxed max-w-md mx-auto">{description}</p>
          <div className="mt-6 inline-flex items-center gap-2 px-4 py-1.5 rounded-lg bg-slate-50 border border-slate-100 text-xs font-semibold text-slate-400 uppercase tracking-wider">
            Planned for a later stage
          </div>
        </div>
      </div>
    </Layout>
  );
}
